import { motion } from "framer-motion";

const bannerVariants: any = {
  hidden: { opacity: 0, y: 24, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function BattlepassBanner() {
  return (
    <motion.div
      variants={bannerVariants}
      initial="hidden"
      animate="visible"
      className="relative overflow-hidden rounded-[4px] cursor-pointer flex items-center justify-between gap-6 px-10 py-5 chakra-petch-font select-none"
      style={{
        background:
          "linear-gradient(to right, #4a1e00 0%, #5c2800 50%, #6b3000 100%)",
      }}
      whileHover={{
        scale: 1.012,
        boxShadow:
          "0 0 40px 10px rgba(255,120,0,0.30), 0 0 80px 20px rgba(255,185,0,0.15)",
      }}
      whileTap={{ scale: 0.985 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      // TODO: Developer — navigate to the Battle Pass screen here (e.g. changeScreen(MENU_SCREEN.Battlepass))
      onClick={() => {}}
    >
      {/* Border */}
      <div className="pointer-events-none absolute inset-0 rounded-[4px] border border-[#FF8C00]/45" />

      {/* Diagonal stripes */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-[25%] right-[15%]"
        style={{
          opacity: 0.08,
          backgroundImage:
            "repeating-linear-gradient(135deg, #c8a020 0px, #c8a020 2px, transparent 2px, transparent 16px)",
        }}
      />

      {/* Ambient orange glow — left */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 10% 50%, rgba(255,140,0,0.55) 0%, transparent 55%)",
        }}
      />

      {/* Ambient amber glow — right */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 92% 50%, rgba(255,185,0,0.40) 0%, transparent 55%)",
        }}
      />

      {/* Left — Crown icon + text */}
      <div className="relative z-10 flex items-center gap-5">
        <CrownIcon />

        <div className="flex flex-col gap-[3px]">
          <span
            className="text-[0.6rem] tracking-[0.35em] uppercase"
            style={{ color: "#FF9D40" }}
          >
            Season 1
          </span>

          <span className="text-[1.05rem] font-black tracking-[0.18em] leading-tight text-white">
            BATTLE PASS
          </span>

          <span
            className="text-[0.68rem] tracking-[0.08em]"
            style={{ color: "rgba(255,180,100,0.60)" }}
          >
            Unlock exclusive rewards &amp; prestige
          </span>
        </div>
      </div>

      {/* Right — CTA pill */}
      <div className="relative z-10 flex-shrink-0">
        <div
          className="flex items-center gap-2 px-5 py-[9px] rounded-[3px] border border-[#FF8C00]/55 text-[0.72rem] tracking-[0.22em] transition-all duration-200"
          style={{
            background: "rgba(255,120,0,0.18)",
            color: "#FFD580",
          }}
        >
          EXPLORE
          <ArrowIcon />
        </div>
      </div>
    </motion.div>
  );
}

// ─── Icons ────────────────────────────────────────────────────────────────────

function CrownIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      {/* Glow circle */}
      <circle cx="23" cy="23" r="22" fill="rgba(255,185,0,0.14)" />
      <circle
        cx="23"
        cy="23"
        r="21.5"
        stroke="rgba(255,185,0,0.50)"
        strokeWidth="1"
      />

      {/* Crown */}
      <path
        d="M10 30 L13 18 L19 24 L23 14 L27 24 L33 18 L36 30 Z"
        fill="url(#crownGrad)"
        stroke="rgba(255,202,88,0.45)"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
      {/* Base bar */}
      <rect
        x="10"
        y="30"
        width="26"
        height="3.5"
        rx="1"
        fill="url(#crownGrad)"
        stroke="rgba(255,202,88,0.35)"
        strokeWidth="0.5"
      />
      {/* Gems */}
      <circle cx="13.5" cy="20" r="1.5" fill="#FF9D00" />
      <circle cx="23" cy="15.5" r="1.5" fill="#FFE29A" />
      <circle cx="32.5" cy="20" r="1.5" fill="#FF9D00" />

      <defs>
        <linearGradient id="crownGrad" x1="10" y1="14" x2="36" y2="34" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFE29A" />
          <stop offset="50%" stopColor="#FFCA58" />
          <stop offset="100%" stopColor="#FF9D00" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6H10M10 6L7 3M10 6L7 9"
        stroke="#FFD580"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
